import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import CommonTable from '../../CommonTable/CommonTable';
import CustomPagination from '../../CustomPagination';

import messages from '../../../locale/messages';
import { updateCurrencyStatus, setBaseCurrency, updatePayoutCurrency } from '../../../actions/siteadmin/CurrencyManagement/currencyManagement';
import { managePaymentCurrency } from '../../../actions/siteadmin/CurrencyManagement/managePaymentCurrency';
import { debounce } from '../../../helpers/debounce';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './CurrencyManagement.css';
class CurrencyManagement extends React.Component {

  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      symbol: PropTypes.string.isRequired,
      isEnable: PropTypes.bool.isRequired,
      isPayment: PropTypes.bool.isRequired,
      isBaseCurrency: PropTypes.bool.isRequired
    })),
    updateCurrencyStatus: PropTypes.any.isRequired,
    setBaseCurrency: PropTypes.any.isRequired,
    managePaymentCurrency: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    data: []
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: ''
    }
  }

  handleSearchChange = debounce((searchList) => {
    const { refetch } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
    };
    this.setState({ searchList, currentPage: 1 });
    refetch(variables);
  }, 250)

  handleUpdateStatus = async (id, status, symbol) => {
    const { updateCurrencyStatus, demoRestriction, refetch } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await updateCurrencyStatus(id, status, symbol);
    refetch();
  }

  handleBaseCurrency = async (id) => {
    const { setBaseCurrency, refetch, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await setBaseCurrency(id);
    await refetch();
  }

  handleUpdatePayoutCurrency = async (id, symbol, isPayoutCurrency) => {
    const { updatePayoutCurrency, refetch, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await updatePayoutCurrency({ id, symbol, isPayoutCurrency });
    refetch();
  }

  handlePaymentCurrency = async (id, isPayment) => {
    const { managePaymentCurrency, refetch, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await managePaymentCurrency(id, isPayment);
    await refetch();
  }

  paginationData = (currentPage) => {
    const { refetch } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage, searchList };
    this.setState({ currentPage, searchList });
    refetch(variables);
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.symbolLabel) },
      { data: formatMessage(messages.baseCurrencyLabel) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.setCurrencyLabel) },
      { data: formatMessage(messages.allowedPaymentCurrency) },
      { data: formatMessage(messages.preferredPayoutCurrency) }
    ]
  }

  tbody = (props) => {
    const { data } = props;
    const { formatMessage } = props.intl;
    return data?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: value?.id },
          { data: value?.symbol },
          { data: value?.isBaseCurrency ? formatMessage(messages.active) : "" },
          {
            data: <select value={value?.isEnable} onChange={(e) => this.handleUpdateStatus(value?.id, value?.isEnable, value?.symbol)}>
              <option value={true}>{formatMessage(messages.enabledLabel)}</option>
              <option value={false}>{formatMessage(messages.disabledLabel)}</option>
            </select>
          },
          {
            data: <span>
              {
                !value?.isBaseCurrency && value?.isEnable && <a href="javascript:void(0)" onClick={() => this.handleBaseCurrency(value?.id)}>
                  <FormattedMessage {...messages.setBaseCurrency} />
                </a>
              }
            </span>
          },
          {
            data: value?.isEnable && <span>
              <a href="javascript:void(0)" onClick={() => this.handlePaymentCurrency(value?.id, value?.isPayment ? "remove" : "add")}>
                {value.isPayment ? <FormattedMessage {...messages.remove} /> :
                  <FormattedMessage {...messages.addLabel} />}
              </a>
            </span>
          },
          {
            data: <span>
              {
                !value?.isPayoutCurrency && value?.isEnable && <a href="javascript:void(0)" onClick={() => this.handleUpdatePayoutCurrency(value?.id, value?.symbol, value?.isPayoutCurrency)}>
                  <FormattedMessage {...messages.setPreferredCurrency} />
                </a>
              }
              {value?.isPayoutCurrency ? <span>{formatMessage(messages.active)} </span> : <span> &nbsp;</span>}
            </span>
          },
        ]
      }
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;
    const { data } = this.props;

    return (
      <div>
        <CommonTable
          title={formatMessage(messages.manageCurrency)}
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          isSearch
          handleSearch={(e) => this.handleSearchChange(e?.target?.value)}
        />
        {
          data?.count > 0 &&
          <div>
            <CustomPagination
              total={data?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.currencies)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  updateCurrencyStatus,
  setBaseCurrency,
  managePaymentCurrency,
  updatePayoutCurrency,
  demoRestriction
};

export default
  compose(
    injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch)
  )(CurrencyManagement);